import React, { createContext, useContext } from "react"
import type { ReactNode } from "react"

type GetDesignColors = () => string[]

const DesignColorsContext = createContext<GetDesignColors | undefined>(
  undefined
)

export function useDesignColorsContext(): GetDesignColors | undefined {
  return useContext(DesignColorsContext)
}

export type DesignColorsProviderProps = {
  /**
   * The colors already used in the current design. A function, not a list,
   * because collecting them can mean walking a whole document: it runs once
   * each time a picker opens, never while the user types.
   */
  getDesignColors: GetDesignColors
  children?: ReactNode
}

/**
 * Supplies the "In this design" colors to every `ColorInput` and `ColorPanel`
 * below it. Mounted by each editing surface that has a design to read from.
 */
export function DesignColorsProvider({
  getDesignColors,
  children
}: DesignColorsProviderProps) {
  return (
    <DesignColorsContext.Provider value={getDesignColors}>
      {children}
    </DesignColorsContext.Provider>
  )
}

DesignColorsProvider.displayName = "DesignColorsProvider"
